/**
 * Routes that show the "click to login" bar below the navbar when the user is logged out.
 */
export function shouldShowLoginPrompt(pathname) {
  if (!pathname) return false;
  return /^\/supermarkets\/[^/]+\/products(\/|$)/.test(pathname);
}
